import { gql } from '@apollo/client';

export const PREPARE_WAITINGLIST_APPROVAL_UPLOAD = gql`
  mutation PrepareWaitingListApprovalUpload(
    $pmcId: String!
    $mimeType: String!
  ) {
    prepareWaitingListApprovalUpload(pmcId: $pmcId, mimeType: $mimeType) {
      attachmentUid
      uploadUrl
    }
  }
`;

export const DELETE_WAITINGLIST_APPROVAL_ATTACHMENT = gql`
  mutation DeleteWaitingListApprovalAttachment($attachmentUid: String!) {
    deleteWaitingListApprovalAttachment(attachmentUid: $attachmentUid)
  }
`;
